var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getIcon = function (icon, size, fill, label) {
    if (label === void 0) { label = ''; }
    var fillEncoded = fill.replace('#', '%23');
    var dataUri = icon.replace('XXXXX', fillEncoded);
    return {
        label: label,
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(dataUri, "\")"),
        width: size,
        height: size,
    };
};
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
var icons = {
    up: "data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Ebold/chevron-up-bold%3C/title%3E%3Cpath fill='XXXXX' d='M63.998 30.18c.513 0 1.028.196 1.424.592l60.802 60.803c.784.783.786 2.05.009 2.828l-8.494 8.494c-.779.779-2.04.78-2.828-.009L64.003 51.981l-50.907 50.907a2.001 2.001 0 0 1-2.829.009l-8.493-8.494a1.995 1.995 0 0 1 .008-2.828l60.803-60.803c.393-.393.908-.59 1.422-.59z'  fill-rule='evenodd'/%3E%3C/svg%3E",
    down: "data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Ebold/chevron-down-bold%3C/title%3E%3Cpath fill='XXXXX' d='M63.998 97.82c.513 0 1.028-.196 1.424-.592l60.802-60.802c.784-.784.786-2.051.009-2.829l-8.494-8.493a1.995 1.995 0 0 0-2.828.008L64.003 76.019 13.096 25.112a2.001 2.001 0 0 0-2.829-.008l-8.493 8.493c-.78.779-.78 2.04.008 2.829l60.803 60.802c.393.393.908.59 1.422.59z'  fill-rule='evenodd'/%3E%3C/svg%3E",
};
export var list = __assign(__assign({}, reset), { borderBottom: '1px solid #c9cfd4', width: '100%' });
export var groupRow = {
    alignItems: 'center',
    backgroundColor: '#F5F9FC',
    borderTop: '1px solid #c9cfd4',
    color: '#000000',
    display: 'flex',
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '150%',
    padding: 16,
};
export var groupRowCollapsible = __assign(__assign({}, groupRow), { cursor: 'pointer', padding: '10px 10px 10px 16px' });
export var groupTitleContainer = {
    flexGrow: 1,
};
export var groupRowCollapsedIcon = {
    ':after': __assign(__assign({}, getIcon(icons.down, 20, '#42505C')), { content: '""', marginBottom: 2, marginLeft: 8, marginRight: 8, marginTop: 8 }),
    ':focus': {
        border: "2px solid ".concat('#1454CC'),
        borderRadius: '2px',
        margin: '-2px',
    },
    ':focus-visible': {
        border: "2px solid ".concat('#1454CC'),
        borderRadius: '2px',
        margin: '-2px',
        outline: 'none',
    },
    ':hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    ':active': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
};
export var groupRowExpandedIcon = {
    ':after': __assign(__assign({}, getIcon(icons.up, 20, '#42505C')), { content: '""', marginBottom: 2, marginLeft: 8, marginRight: 8, marginTop: 8 }),
    ':focus': {
        border: "2px solid ".concat('#1454CC'),
        borderRadius: '2px',
        margin: '-2px',
    },
    ':focus-visible': {
        border: "2px solid ".concat('#1454CC'),
        borderRadius: '2px',
        margin: '-2px',
        outline: 'none',
    },
    ':hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    ':active': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
};
export var actions = {
    alignItems: 'center',
    display: 'flex',
    paddingRight: 8,
    '& button': {
        boxShadow: 'none',
        color: '#1454CC',
        marginBottom: 4,
        marginLeft: 8,
        marginRight: 0,
        marginTop: 4,
        ':focus': {
            border: "2px solid ".concat('#1454CC'),
            color: '#1454CC',
        },
        ':focus-visible': {
            '--box-shadow-color': 'none',
            color: '#1454CC',
            outline: 'none',
        },
        ':hover': {
            backgroundColor: '#C0D9F2',
            color: '#1454CC',
            boxShadow: 'none',
        },
        ':active': {
            backgroundColor: '#A2C7EB',
            border: 'unset',
            boxShadow: 'none',
            color: '#1454CC',
        },
    },
};
export var actionsSelected = __assign(__assign({}, actions), { backgroundColor: '#D5E6F6', '& button': {
        boxShadow: 'none',
        color: '#1454CC',
        marginBottom: 4,
        marginLeft: 8,
        marginRight: '-2px',
        marginTop: 4,
        ':focus': {
            color: '#1454CC',
        },
        ':focus-visible': {
            '--box-shadow-color': 'none',
            color: '#1454CC',
            outline: 'none',
        },
        ':hover': {
            backgroundColor: '#C0D9F2',
            boxShadow: 'none',
            color: '#1454CC',
        },
        ':active': {
            backgroundColor: '#A2C7EB',
            boxShadow: 'none',
            color: '#1454CC',
        },
    } });
export var actionsSelectedDisabled = __assign(__assign({}, actionsSelected), { backgroundColor: "#DFE5EB !important" });
export var itemContainer = {
    backgroundColor: '#FFFFFF',
    borderTop: '1px solid #c9cfd4',
    color: '#000000',
    display: 'flex',
    fontSize: 16,
    fontWeight: '450',
    lineHeight: '125%',
};
export var itemContainerClickable = {
    ':hover': {
        backgroundColor: '#e1e6eb',
        cursor: 'pointer',
    },
};
export var itemContainerDisabled = __assign(__assign({}, itemContainer), { color: "#8A959E !important", cursor: 'not-allowed', ':hover': {} });
export var itemContainerSelected = __assign(__assign({}, itemContainer), { ':hover': __assign(__assign({}, itemContainer[':hover']), { backgroundColor: itemContainer.backgroundColor, cursor: 'pointer' }) });
export var item = {
    alignItems: 'center',
    flexGrow: 1,
    padding: 16,
};
export var itemSelected = __assign(__assign({}, item), { backgroundColor: '#D5E6F6' });
export var itemSelectedDisabled = __assign(__assign({}, itemSelected), { backgroundColor: "#DFE5EB !important" });
export var inputContainer = {
    alignItems: 'center',
    display: 'flex',
    padding: "0 0 0 ".concat(16, "px"),
};
export var inputContainerSelected = __assign(__assign({}, inputContainer), { backgroundColor: '#D5E6F6' });
export var inputContainerSelectedDisabled = __assign(__assign({}, inputContainerSelected), { border: '2px solid #75828C' });
export var inputGroupContainer = {
    alignItems: 'center',
    display: 'flex',
    padding: "0 ".concat(16, "px 0 2px"),
};
export var inputGroupContainerSelected = __assign({}, inputGroupContainer);
export var inputGroupContainerSelectedDisabled = __assign(__assign({}, inputGroupContainerSelected), { border: '2px solid #75828C' });
export var input = {
    ':hover': {
        cursor: 'pointer',
    },
    backgroundColor: '#D5E6F6',
    height: 24,
    width: 24,
    ':focus-visible': {
        marginRight: '3px',
        outlineColor: '#347abe',
    },
};
export var inputDisabled = {
    cursor: 'not-allowed',
    height: 24,
    width: 24,
    ':focus-visible': {
        outline: 'none',
    },
};
var ribbon = {
    content: '""',
    display: 'block',
    width: 8,
};
// Note: do not remove the label prop in the items below, as it forces emotion hashes to be unique;
//       if there are duplicates, the colors aren't displayed!
export var positive = {
    ':before': __assign(__assign({}, ribbon), { label: 'positive', backgroundColor: '#12B212' }),
};
export var info = {
    ':before': __assign(__assign({}, ribbon), { label: 'info', backgroundColor: '#2D6BE0' }),
};
export var warning = {
    ':before': __assign(__assign({}, ribbon), { label: 'warning', backgroundColor: '#FFB900' }),
};
export var negative = {
    ':before': __assign(__assign({}, ribbon), { label: 'negative', backgroundColor: '#FC0020' }),
};
export var pending = {
    ':before': __assign(__assign({}, ribbon), { label: 'pending', backgroundColor: '#8E2CD9' }),
};
export var color1 = {
    ':before': __assign(__assign({}, ribbon), { label: 'citron1', backgroundColor: '#25AFB8' }),
};
export var color2 = {
    ':before': __assign(__assign({}, ribbon), { label: 'citron2', backgroundColor: '#005F66' }),
};
export var color3 = {
    ':before': __assign(__assign({}, ribbon), { label: 'citron3', backgroundColor: '#8E7DFA' }),
};
export var color4 = {
    ':before': __assign(__assign({}, ribbon), { label: 'citron4', backgroundColor: '#FE744C' }),
};
export var color5 = {
    ':before': __assign(__assign({}, ribbon), { label: 'citron5', backgroundColor: '#8E2CD9' }),
};
export var color6 = {
    ':before': __assign(__assign({}, ribbon), { label: 'citron6', backgroundColor: '#410073' }),
};
export var color7 = {
    ':before': __assign(__assign({}, ribbon), { label: 'citron7', backgroundColor: '#FF4DBF' }),
};
export var color8 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#800053' }),
};
export var color9 = {
    ':before': __assign(__assign({}, ribbon), { label: 'citron9', backgroundColor: '#2D6BE0' }),
};
export var color10 = {
    ':before': __assign(__assign({}, ribbon), { label: 'citron10', backgroundColor: '#00328F' }),
};
export var color11 = {
    ':before': __assign(__assign({}, ribbon), { label: 'citron11', backgroundColor: '#CC9500' }),
};
export var color12 = {
    ':before': __assign(__assign({}, ribbon), { label: 'citron12', backgroundColor: '#C9001A' }),
};
